import moment from 'moment'
import axios from "../../../axios";
import store from "@/store/store";
import state from "@/store/state";
import customerChats from "@/http/requests/customerChats";
import { ChatTicketService } from "@/db/chatTicket_service";
import { getCurrentTenant, populateParamTab } from '@/utils'

export default {
  fetch(
    instanceIds,
    finishedTickets = undefined,
    searchQuery = '',
    allUsers = undefined,
    paginationPage = 1,
    paginationLimit = 10,
    customerId = undefined,
    inbox = false,
    inboxDepartment = null,
    isCampaign = null,
    groupIds = [],
    userId = undefined
  ) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query {
          chatTickets (
            instance_ids: [${instanceIds}],
            ` + (searchQuery === '' ? '' : `search_query: "${searchQuery}",`) + `,
            ` + (finishedTickets === undefined ? '' : `finished_tickets: ${finishedTickets},`) + `,
            ` + (allUsers === undefined ? '' : `all_users: ${allUsers},`) + `,
            ` + (paginationPage === undefined ? '' : `pagination_page: ${paginationPage},`) + `,
            ` + (paginationLimit === undefined ? '' : `pagination_limit: ${paginationLimit},`) + `,
            ` + (customerId === undefined ? '' : `customer_id: ${customerId},`) + `,
            ` + (!inbox ? '' : `inbox: ${inbox},`) + `,
            ` + (!inboxDepartment ? '' : `inbox_department_id: ${inboxDepartment},`) + `,
            ` + (isCampaign === null ? '' : `is_campaign: ${Number(isCampaign)}`) + `,
            ` + (!groupIds || !groupIds.length ? '' : `group_ids: [${groupIds}]`) + `,
            ` + (!userId ? '' : `user_id: ${userId}`) + `
          ) {
            total_pages,
            items {
              id,
              campaign_id,
              is_campaign,
              instance_id,
              user_id,
              finished_ticket,
              open_by_template,
              customer_id,
              last_msg,
              protocol,
              priority,
              started_at,
              finished_at,
              last_cost_created_at,
              is_finishing,
              unseenMsg,
              isNotResponded,
              inbox,
              pickableInboxChat,
              createdAt,
              curretTimestamp,
              is_research,
              bot_is_active,
              user {
                id,
                name,
                image,
                deleted_at
              },
              instance {
                id
              },
              campaign{
                id,
                name
              },
              inbox_department_id,
              customer {
                id,
                name,
                image,
                address,
                open_field,
                is_favorite,
                phone_number,
                is_blacklisted,
                is_blacklisted_campaign,
                document_register,
                group_of_customer {
                  id,
                  group_id,
                  customer_id,
                  name,
                  color_tag
                }
              },
              customerLastChat {
                id,
                type,
                sent_at,
                message,
                tag_type,
                unseen_msg,
                is_temp,
                caption,
                document_name,
                is_bot_message,
                document_mimetype,
                chatTicket {
                  id,
                  is_research
                }
              }
            }
          }
        }
      `
    })
  },
  infos(chatContactId) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query {
          customerInfos (
            id: ${chatContactId}
          ) {
            id,
            name,
            phone_number,
            image,
            is_blacklisted,
            is_blacklisted_campaign,
            is_favorite,
            open_field,
            address,
            document_register
          }
        }
      `
    })
  },
  chatTicketByUserId(args){
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
      query {
        chatTicketsUserId (
          instance_ids: [${args.instanceIds}],
          ` + (args.finishedTickets === undefined ? '' : `finished_tickets: ${args.finishedTickets},`) + `,
          ` + (!args.unseenMsg ? '' : `unseen_msg: ${args.unseenMsg},`) + `,
          ` + (args.allUsers === undefined ? '' : `all_users: ${args.allUsers},`) + `,
          ` + (!args.inbox ? '' : `inbox: ${args.inbox},`) + `,
          ` + (!args.inboxDepartment ? '' : `inbox_department_id: ${args.inboxDepartment},`) + `,
          ` + (args.isCampaign === null ? '' : `is_campaign: ${Number(args.isCampaign)}`) + `,
          ` + (!args.groupIds || !args.groupIds.length ? '' : `group_ids: [${args.groupIds}]`) + `,
          ` + (args.userId === undefined ? '' : `user_id: ${args.userId}`) + `
        )
      }
    `
    })
  },
  async infosChat(chatTicketId) {
    await store.dispatch('setShowLoadingOverlay', false);
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query {
          chatTicketInfos (
            id: ${chatTicketId}
          ) {
            id,
            inbox,
            user_id,
            last_msg,
            protocol,
            priority,
            unseenMsg,
            createdAt,
            is_research,
            campaign_id,
            is_campaign,
            instance_id,
            customer_id,
            started_at,
            finished_at,
            is_finishing,
            bot_is_active,
            isNotResponded,
            curretTimestamp,
            finished_ticket,
            pickableInboxChat,
            inbox_department_id,
            user {
              id,
              name,
              image,
              deleted_at
            },
            instance {
              id,
              name,
              nickname
            },
            campaign{
              id,
              name
            },
            customer {
              id,
              name,
              image,
              address,
              open_field,
              is_favorite,
              phone_number,
              is_blacklisted,
              is_blacklisted_campaign,
              document_register,
              group_of_customer {
                id,
                group_id,
                customer_id,
                name,
                color_tag
              }
            },
            customerLastChat {
              id,
              type,
              sent_at,
              message,
              is_temp,
              tag_type,
              unseen_msg,
              document_name,
              is_bot_message,
              document_mimetype,
              chatTicket {
                id,
                is_research
              }
            }
          }
        }
      `
    })
  },
  fetchCustomerChats(customerId, instanceId, finishedTickets, allUsers = false, inbox = false) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query {
          customerChats (
            customer_id: ` + customerId + `,
            instance_id: ` + instanceId + `,
            finished_tickets: ` + finishedTickets + `,
            all_users: ` + allUsers + `
            inbox: ` + inbox + `
          ) {
            id,
            type,
            whatsapp_message_id,
            sent_at,
            message,
            whatsapp_deleted_at,
            tag_type,
            unseen_msg,
            is_temp,
            caption,
            is_edited,
            document_name,
            is_bot_message,
            document_mimetype,
            parent_id,
            recovered,
            off_customer_chat,
            ack,
            is_log_message,
            customerChatStatus {
              id,
              url,
              caption,
              mimetype,
            },
            customerChatReactions{
              id,
              ack,
              type,
              sent_at,
              customer_id,
              reaction_text,
              customer_chat_id,
            },
            parentCustomerChat {
              id,
              whatsapp_message_id,
              type,
              sent_at,
              message,
              tag_type,
              unseen_msg,
              is_temp,
              caption,
              is_edited,
              document_name,
              is_bot_message,
              document_mimetype,
              parent_id,
              recovered,
              off_customer_chat,
              customerChatStatus {
                id
                caption
                mimetype
                url
              },
            },
            chatTicket {
              id,
              campaign_id,
              protocol,
              started_at,
              finished_at,
              is_finishing,
              is_research,
              open_by_template,
              grade,
              user {
                id
              }
            }
          }
        }
      `
    })
  },
  fetchOldCustomerChats(customerId, instanceId, maxId, limit) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query {
          oldCustomerChats (
            max_id: ` + maxId + `,
            limit: ` + limit + `,
            customer_id: ` + customerId + `,
            instance_id: ` + instanceId + `
          ) {
            id,
            type,
            sent_at,
            message,
            tag_type,
            unseen_msg,
            is_temp,
            caption,
            document_name,
            is_bot_message,
            document_mimetype,
            is_log_message
          }
        }
      `
    })
  }, 
  sendChatMessage(toNumber, message, instanceId, userId, replyMessageId, hash = null, timeout = 0) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
    axios.defaults.timeout = timeout;

    return axios.post('', {
      query: `
        mutation {
          sendMessage (
            user_id: ${userId},
            to_number: "${toNumber}",
            message: "${message}",
            instance_id: ${instanceId},
            reply_message_id: "${replyMessageId}",
            from_chat: ${true},
            hash: "${hash}"
          )
        }
      `
    })
  },
  sendChatImage(toNumber, imageUrl, fileName, instanceId, userId, hash, imageCaption, timeout = 0) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    axios.defaults.timeout = timeout;

    return axios.post('', {
      query: `
        mutation {
          sendImageSelenium (
            user_id: ${userId},
            image_url: "${imageUrl}",
            document_name: "${fileName}",
            to_number: "${toNumber}",
            instance_id: ${instanceId},
            from_chat: ${true},
            hash: "${hash}",
            image_caption: "${imageCaption.replace(/"/g, '\\"')}"
          )
        }
      `
    })
  },
  sendChatAudio(toNumber, fileUrl, fileCaption, instanceId, userId, hash, timeout = 0, replyMessageId = null) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    axios.defaults.timeout = timeout;

    return axios.post('', {
      query: `
        mutation {
          sendAudioSelenium (
            user_id: ${userId},
            file_url: "${fileUrl}",
            file_caption: "${fileCaption}",
            to_number: "${toNumber}",
            instance_id: ${instanceId},
            from_chat: ${true},
            hash: "${hash}",
            `+ (replyMessageId != null ? `reply_message_id: "${replyMessageId}",` : '') + `,
          )
        }
      `
    })
  },
  sendChatSticker(toNumber, imageUrl, instanceId, userId, hash, timeout = 0) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    axios.defaults.timeout = timeout;

    return axios.post('', {
      query: `
        mutation {
          sendStickerSelenium (
            user_id: ${userId},
            image_url: "${imageUrl}",
            to_number: "${toNumber}",
            instance_id: ${instanceId},
            from_chat: ${true},
            hash: "${hash}"
          )
        }
      `
    })
  },
  resetCustomerUnseenMsgs(customerId, instanceId) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          resetCustomerUnseenMsgs (id: ` + customerId + `, instance_id: ` + instanceId + `)
        }
      `
    })
  },
  sendChatComment(toNumber, message, instanceId, hash = null, timeout = 0) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
    axios.defaults.timeout = timeout;

    return axios.post('', {
      query: `
        mutation {
          createChatComment (
            message: "${message}",
            to_number: "${toNumber}",
            instance_id: ${instanceId},
            hash: "${hash}"
          )
        }
      `
    })
  },
  sendReactionToMessage(reaction, customerChatId, instanceId) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';

    return axios.post('', {
      query: `
        mutation {
          sendReactionSelenium (
            customer_chat_id: ${customerChatId},
            reaction_text: "${reaction}",
            instance_id: ${instanceId},
            from_chat: ${true}
          )
        }
      `
    })
  },
  fetchSumOfTickets(instanceIds) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query {
          sumOfTickets (
            instance_ids: [${instanceIds}],
            make_in_list: ${true}
          ) {
            inbox_list{
              id,
              customer_id,
              is_campaign,
              instance_id,
              bot_is_active,
              is_research,
              unseenMsg
            },
            my_chats_list{
              id,
              customer_id,
              is_campaign,
              instance_id,
              bot_is_active,
              is_research,
              unseenMsg
            }
          }
        }
      `
    })
  },
  queryToLoad(param) {
    return `
        query {
          chatTickets (
            instance_ids: [${param.instanceIds}],
            ` + (param.finishedTickets === undefined ? '' : `finished_tickets: ${param.finishedTickets},`) + `,
            ` + (param.allUsers === undefined ? '' : `all_users: ${param.allUsers},`) + `,
            ` + (param.paginationPage === undefined ? '' : `pagination_page: ${param.paginationPage},`) + `,
            ` + (param.paginationLimit === undefined ? '' : `pagination_limit: ${param.paginationLimit},`) + `,
            ` + (param.customerId === undefined ? '' : `customer_id: ${param.customerId},`) + `,
            ` + (!param.inbox ? '' : `inbox: ${param.inbox},`) + `,
            ` + (!param.inboxDepartment ? '' : `inbox_department_id: ${param.inboxDepartment},`) + `,
            ` + (!param.isCampaign ? '' : `is_campaign: ${Number(param.isCampaign)}`) + `
            ` + (!param.botIsActive ? '' : `bot_is_active: ${Number(param.botIsActive)}`) + `
            ` + (!param.updated_at ? '' : `updated_at: "${param.updated_at}"`) + `
            ` + (!param.groupIds || !param.groupIds.length ? '' : `group_ids: [${param.groupIds}]`) + `
          ) {
            total_pages,
            items {
              id,
              campaign_id,
              is_campaign,
              instance_id,
              user_id,
              priority,
              finished_ticket,
              customer_id,
              last_msg,
              protocol,
              started_at,
              finished_at,
              last_cost_created_at,
              is_finishing,
              unseenMsg,
              isNotResponded,
              inbox,
              open_by_template,
              pickableInboxChat,
              createdAt,
              curretTimestamp,
              is_research,
              bot_is_active,
              user {
                id,
                name,
                image,
                deleted_at
              },
              instance {
                id,
                name,
                nickname
              },
              campaign{
                id,
                name
              },
              inbox_department_id,
              customer {
                id,
                name,
                image,
                address,
                open_field,
                is_favorite,
                phone_number,
                is_blacklisted,
                is_blacklisted_campaign,
                document_register,
                group_of_customer {
                  id,
                  group_id,
                  customer_id,
                  name,
                  color_tag
                }
              },
              customerLastChat {
                id,
                type,
                sent_at,
                message,
                tag_type,
                unseen_msg,
                is_temp,
                caption,
                document_name,
                is_bot_message,
                document_mimetype,
                chatTicket {
                  id,
                  is_research
                }
              }
            }
          }
        }
      `
  },
    generateParam() {
        let tabs = ['closed', 'opened', 'my_chats', 'inbox'];
        let tabsCampaign = ['closed', 'opened', 'my_chats'];
        let tabsMaria = ['closed', 'opened', 'my_chats', 'inbox'];
        let tabsUnseenMsg = ['closed', 'opened', 'my_chats', 'inbox'];
        let params = [];
        let tempParam;

        tabs.forEach(item => {
          tempParam = populateParamTab(item, false)
          tempParam.paginationPage = 1;
          tempParam.paginationLimit = 10;
          params.push(tempParam);
        });

        tabsCampaign.forEach(item => {
          tempParam = populateParamTab(item, true, false, false)
          tempParam.paginationPage = 1;
          tempParam.paginationLimit = 10;
          params.push(tempParam);
        });

        tabsMaria.forEach(item => {
          tempParam = populateParamTab(item, false, true, false)
          tempParam.paginationPage = 1;
          tempParam.paginationLimit = 10;
          params.push(tempParam);
        });

        tabsUnseenMsg.forEach(item => {
          tempParam = populateParamTab(item, false, false, true)
          tempParam.paginationPage = 1;
          tempParam.paginationLimit = 10;
          params.push(tempParam);
        });

        return params;
    },
    async firstLoad(update = false) {
        await store.dispatch('setShowLoadingOverlay', false)

        if (process.env.VUE_APP_ENVIRONMENT === 'development') {
            console.log('start Load ... ');
        }
        await store.dispatch('setShowLoadingOverlay', false)
        let promises = [];
        let params = '';
        if (!update) {
            params = this.generateParam();
        } else {
            let d = new Date(state.socketConnectionCount)

            params = [{
                instanceIds: store.getters["instance/chosenInstanceIds"],
                updated_at: moment(d).format('YYYY-MM-DD HH:mm:ss').toString(),
                inbox: true
            }];
        }

        axios.defaults.timeout = 0;
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        params.forEach(param => {
            promises.push(axios.post('', {query: this.queryToLoad(param)}))
        })

        await this.executeFetch(promises, update);
    },
    async executeFetch(promises, update = false) {
        let logs = {
            Atendimentos: 0,
            Mensagens: 0,
            Requisicoes: 0,
            "Tempo de carga (segundos)": 0
        }
        
        const start = performance.now();
        return await Promise.all(promises)
            .then(async (datas) => {
                logs.Atendimentos = 0;
                for (const data of datas) {
                    if (data.data.data.chatTickets && data.data.data.chatTickets.items.length > 0) {
                        await this.insertData(data.data.data.chatTickets, update)
                        logs.Atendimentos += data.data.data.chatTickets.items.length;
                        let chats = await customerChats.loadPaginated(data.data.data.chatTickets.items, 1, 80, update)
                        logs.Mensagens += chats
                    }
                }
                const end = performance.now();
                logs.Requisicoes = logs.Atendimentos + logs.Mensagens
                logs["Tempo de carga (segundos)"] = ((end - start) / 1000).toFixed(2)
                if (process.env.VUE_APP_ENVIRONMENT === 'development') {
                    console.table(logs)
                }
                return datas.length
            })
            .catch((error) => {
                console.log(error);
            })
    },
    async insertData(chatTickets, update = false) {
        const ctService = new ChatTicketService();
        await ctService.insert(chatTickets.items, false, !update);
        if ( update && chatTickets.items.length > 0 ) {
            await ctService.updatePickable(chatTickets.items[0].instance_id);
        }
    },
}
  
